<template>
  <div class="order-block order-policyholder" id="personalInsuranceInfo">
    <div class="title personal">
      投保人信息
      <div class="self-btn">
        <el-switch
          v-model="insuranceData.is_self_insure"
          :on-value="1"
          :off-value="0"
          on-text=""
          off-text=""
          on-color="#599FFF"
          off-color="#DEE2E6"
          >
        </el-switch>
        被保人本人投保
      </div>    
    </div>

    <el-form class="insurance-order" :model="insuranceData" ref="dataForm" :rules="rules" :inline="true" label-position="top">
      <div class="content" v-if="!insuranceData.is_self_insure">
        <el-form-item label="" prop="applicant.cname" :rules="rules['insurants.cname']">
          <div class="form-item-label" solt="label">
            姓名<span class="required">*</span>
          </div>
          <!-- 更改部分 -->
          <el-input v-model.trim="insuranceData.applicant.cname"
            placeholder="请输入" :maxlength="15" @blur="calculatePinyin(insuranceData.applicant)"></el-input>
        </el-form-item>

        <el-form-item label="" prop="applicant.ename" :rules="rules['insurants.ename']">
          <div class="form-item-label" solt="label">
            姓名拼音<span class="required">*</span><span class="sub-label">(与护照上的姓名拼音一致即可)</span>
          </div>
          <el-input v-model.trim="insuranceData.applicant.ename" placeholder="请输入" :maxlength="60"></el-input>
        </el-form-item>

        <el-form-item label="" prop="applicant.card_type" :rules="rules['insurants.card_type']">
          <div class="form-item-label" solt="label">
            证件类型<span class="required">*</span>
          </div>
          <el-select v-model="insuranceData.applicant.card_type" placeholder="请选择">
            <el-option label="身份证" :value="1" v-if="supportIdCard"></el-option>
            <el-option label="护照" :value="2" v-if="supportPassport"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="" prop="applicant.card_code"
          :rules="insuranceData.applicant.card_type === 2 ? rules['insurants.passport'] : rules['insurants.idCard']">
          <div class="form-item-label" solt="label">
            证件号码<span class="required">*</span>
          </div>
          <el-input v-model.trim="insuranceData.applicant.card_code" placeholder="请输入" :maxlength="18"
            @change="extractInfoFromIdcard(insuranceData.applicant)" ></el-input>
        </el-form-item>

        <el-form-item label="" prop="applicant.birthday" :rules="rules['insurants.birthday']">
          <div class="form-item-label" solt="label">
            出生日期<span class="required">*</span>
          </div>
          <el-date-picker v-model.trim="insuranceData.applicant.birthday" format="yyyy年MM月dd日" default-value="1988-06-01" placeholder="请选择"
            :editable="false" type="date" :picker-options="pickerOptionsForBirthday">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="" prop="applicant.sex" :rules="rules['insurants.sex']">
          <div class="form-item-label" solt="label">
            性别<span class="required">*</span>
          </div>
          <el-radio-group v-model="insuranceData.applicant.sex">
            <el-radio class="radio" :label="1">男</el-radio>
            <el-radio class="radio" :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="" prop="applicant.mobile" :rules="rules['insurants.mobile']">
          <div class="form-item-label" solt="label">
            手机号码<span class="required">*</span>
          </div>
          <el-input v-model.trim="insuranceData.applicant.mobile" placeholder="请输入" :maxlength="11"></el-input>
        </el-form-item>

        <el-form-item label="" prop="applicant.job" v-if="insuranceData.job_set" :rules="rules['insurants.job']">
          <div class="form-item-label" solt="label">
            职业<span class="required">*</span>
          </div>
          <el-cascader
            :options="transformJob"
            v-model="insuranceData.applicant.job"
          >
          </el-cascader>
        </el-form-item>
      </div>
      <!-- 开启被保人投保 -->
      <div class="content self-insure-content" v-else>
        <div class="self-insurce-applicant-list" v-if="nonEmptyInsurants.length">
          <div class="m-b-12">
            自动将被保人设置为投保人
          </div>
          <div class="applicant-list">
            <div class="applicant-item" v-for="(item, index) in nonEmptyInsurants" :key="index"> 
              {{ item.cname }}
            </div>
          </div>
        </div>

        <el-form-item label="" prop="mobile_phone" :rules="rules['insurants.mobile']" class="m-b-15">
          <div class="form-item-label m-b-12" solt="label">  
            手机号码<span class="required">*</span>
          </div>
          <el-input v-model.trim="insuranceData.mobile_phone" placeholder="请输入" :maxlength="11"></el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>


<script>
import 'pinyin4js';
import insuranceInfoService, { rules } from '@/pages/insurance/services/insurance-info-service';
import utils from '@/libs/utils';


export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rules,
      insuranceData: undefined,
      pickerOptionsForBirthday: {
        disabledDate() {
          return false;
        },
      },
    };
  },
  computed: {
    // 过滤空白的数据
    nonEmptyInsurants() {
      if (!this.insuranceData.insurants) return [];
      // return this.insuranceData.insurants.filter(it => Object.values(it).some(val => val)); // 过滤掉所有属性都是空的数据
      return this.insuranceData.insurants.filter(it => it.cname); // 输入名字的
    },


    // 投保人支持的证件类型
    supportPassport() {
      // 1身份证 2护照
      return this.insuranceData.applicant_type_set && this.insuranceData.applicant_type_set.includes(2);
    },
    supportIdCard() {
      // 1身份证 2护照
      return this.insuranceData.applicant_type_set && this.insuranceData.applicant_type_set.includes(1);
    },
  },
  watch: {
    value: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.insuranceData)) {
          this.insuranceData = utils.deepCopy(val);
        }
      },
      deep: true,
      immediate: true,
    },
    insuranceData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
    'insuranceData.is_self_insure': {
      handler(val) {
        // 如果开启被保人投保则与投保人关系强制为本人
        if (val) {
          this.insuranceData.insurants = this.insuranceData.insurants.map(it => ({ ...it, relation_id: 1 })); 
        } else { // 关闭直接清楚
          this.insuranceData.insurants = this.insuranceData.insurants.map(it => ({ ...it, relation_id: undefined })); 
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 从身份证抽取信息，并自动填入
    extractInfoFromIdcard(item) {
      insuranceInfoService.extractInfoFromIdcard(item);
    },
    // 根据输入的汉字计算拼音
    calculatePinyin(item, needEmptyEname, length) {
      if (item.cname && (needEmptyEname || !item.ename)) {
        item.ename = PinyinHelper.convertToPinyinString(item.cname, '#', PinyinFormat.WITHOUT_TONE)
          .split('#')
          .map(pin => pin.substring(0, 1).toUpperCase() + pin.substring(1))
          .join('')
          .substring(0, length);
        this.$forceUpdate();
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            console.log('ssdsdsapplicant', this.insuranceData);// 抛id出去，做滚动
          }
        });
      });
    },

  },
};
</script>


<style lang="less" scoped>
.personal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
  .self-btn {
    font-size: 14px;
    color: #5F666E;
    line-height: 20px;
    font-weight: normal;
    display: flex;
    align-items: center;
    /deep/ .el-switch {
      transform: scale(0.7);
      margin-right: 2px;
      &.is-disabled.is-checked {
        .el-switch__core {
          background-color: rgba(89, 159, 255, .8)!important;
          border-color: rgba(89, 159, 255, .8)!important;
        }
      }
    }
  }
}
.self-insure-content {
  display: flex;
  flex-direction: column;
  .self-insurce-applicant-list {
    padding: 0 15px;
    margin-bottom: 8px;
    .m-b-12 {
      margin-bottom: 12px;
    }
    .applicant-list {
      display: flex;
      flex-wrap: wrap;
      .applicant-item {
        padding: 0 46px;
        height: 28px;
        line-height: 28px;
        background: #FAFBFC;
        border-radius: 2px;
        border: 1px solid #DEE2E6;
        font-size: 14px;
        color: #2F333D;
        margin: 0 16px 12px 0;
      }
    }
  }
}
.el-form-item .form-item-label.m-b-12 {
  margin-bottom: 12px;
}
.el-form-item.policy-holder-item {
  margin-bottom: 8px;
  width: 100%;
}
.el-form-item.m-b-15 {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/personal-insurance-info.vue